import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@mantine/core';
import styles from './styles.module.scss';

const MantineCheckBox = (props) => {
  const { checked, handleChange } = props;
  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      classNames={{
        input: styles.input
      }}
    />
  );
};

MantineCheckBox.propTypes = {
  checked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default MantineCheckBox;
